import { clearStorage, getItemStepz, setItemStepz } from "src/helpers/localstorage";
import { getValidaURLAcceso, postURLAcceso } from "src/service/APIService"
import { types } from "../types/types";
import { setFormaPago, setInputEmail } from "./pago";
import { finishLoadingUIPago, setCompletado, startLoadingUIPago } from "./ui";
import { setAlert } from "./alert";



export const submitIdentificacionToURLAcceso = (identificacion, navigate) => {
    return (dispatch) => {

        // obtener url con token
        dispatch(startloadingURLAcceso());
        postURLAcceso(identificacion)
            .then(
                data => {
                    if (!data.error) {

                        const { url } = data;
                        const token = url.split('/')[url.split('/').length - 2];
                        const idAcceso = url.split('/')[url.split('/').length - 1];

                        navigate(`multipagos/${token}/${idAcceso}`);
                    } else {
                        if(data.status === 404){
                            dispatch(setAlert({ color: 'danger', message: `Por favor, verifica tu número de cédula o asegúrate de tener póliza con pagos pendientes.` }));
                        }
                    }
                    dispatch(finishloadingURLAcceso());
                }
            )
    }
}

// loading de URL ACCESO
export const startloadingURLAcceso = () => ({
    type: types.startloadingSetURLAcceso
});

export const finishloadingURLAcceso = () => ({
    type: types.finishloadingSetURLAcceso
});


export const startCheckingToken = (token, idacceso) => {

    idacceso ? setItemStepz({ idAcceso: idacceso, token: token }) : clearStorage();

    return (dispatch) => {
        dispatch(startLoadingUIPago());
        getValidaURLAcceso({
            token,
            idacceso
        }).then(
            data => {
                if (!data.error) {
                    const { nombre, identificacion, paso, completado } = data;

                    // step currrent
                    setItemStepz({ step: paso });

                    // email
                    let email = getItemStepz()?.email || '';
                    dispatch(setInputEmail({ name: 'email', value: email }));
                    // identificacion
                    dispatch(setIdentificacion({ nombre, identificacion }));

                    // completado(N,S,E)
                    dispatch(setCompletado(completado));

                    // origen -> forma de pago
                    let idorigen = getItemStepz()?.pay || 0;
                    dispatch(setFormaPago(idorigen))

                } else {
                    dispatch(setIdentificacion(null));
                    dispatch(setCompletado(""));
                    clearStorage();
                }
                dispatch(finishLoadingUIPago());
            }
        )
    }
}


export const setIdentificacion = (identificacion) => ({
    type: types.setIdentificacion,
    payload: identificacion

});

